// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 339 ? "storefront" : chunkId) + "." + {"73":"269018af","339":"b5e00b86"}[chunkId] + ".chunk.css";
};